// Renders the uploaded Wealth First Inc. logo (white-on-black PNG) as a
// pure-color (gold) silhouette using CSS luminance masking.
// Set `color` to override the brass/gold default.

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ultra-net-worth/artifacts/hdvi7b2w_%C2%AEt_20250713_065113_0000~4.png";

export default function LogoMark({
  color = "var(--brass)",
  height = 60,
  width,
  className = "",
  style = {},
  testId = "logomark",
  ariaLabel = "Wealth First Inc.",
}) {
  return (
    <span
      role="img"
      aria-label={ariaLabel}
      data-testid={testId}
      className={className}
      style={{
        display: "inline-block",
        width: width || `${height}px`,
        height: `${height}px`,
        backgroundColor: color,
        WebkitMaskImage: `url(${LOGO_URL})`,
        maskImage: `url(${LOGO_URL})`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskMode: "luminance",
        maskMode: "luminance",
        ...style,
      }}
    />
  );
}

export { LOGO_URL };
